module.exports = __webpack_public_path__ + "static/media/image-monday.c02524f9.jpg";